<template>
  <div class="app-container">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="@/assets/back.png" alt="返回" />
          <span>返回</span>
        </div>
      </div>
      <Title class="mt20">基础信息</Title>
      <el-descriptions class="margin-top" title="" :column="3">
        <el-descriptions-item label="套餐金额">{{info.rechargeMoney}}元</el-descriptions-item>
        <el-descriptions-item label="获得奖励">{{info.rewardType==1?info.name:info.rewardType==2?info.xiaoduMoney+'个零售价':'-'}}</el-descriptions-item>
        <el-descriptions-item label="是否限制时间">{{info.isLimit?'限制':'不限制'}}</el-descriptions-item>
        <el-descriptions-item label="套餐上架时间">{{info.showTime}}</el-descriptions-item>
        <el-descriptions-item label="体验班充值大区分润比例">{{info.experienceRatio}}%</el-descriptions-item>
        <el-descriptions-item label="研修班充值大区分润比例">{{info.trainingRatio}}%</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{info.createdTime}}</el-descriptions-item>
        <el-descriptions-item label="状态">{{info.state?'上架':'下架'}}</el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>

<script>
export default {
  props: ['rowItem'],
  data() {
    return {
      info: {}
    }
  },
  created() {
    this.handleShow()
  },
  methods: {
    handleShow() {
      this.info = this.rowItem
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
